import type { I18nFn } from '#/i18n/types/I18nFn';

export enum EducationLevel {
  NO_REQUIREMENT = 'NO_REQUIREMENT',
  HIGH_SCHOOL = 'HIGH_SCHOOL',
  TWO_YEAR_DEGREE = 'TWO_YEAR_DEGREE',
  FOUR_YEAR_DEGREE = 'FOUR_YEAR_DEGREE',
  MASTERS_DEGREE = 'MASTERS_DEGREE',
  JD = 'JD',
  PHD = 'PHD',
  MD = 'MD',
  OTHER = 'OTHER',
}

export function EDUCATION_LEVELS(i18n: I18nFn) {
  return {
    [EducationLevel.NO_REQUIREMENT]: i18n('No Education Requirement'),
    [EducationLevel.HIGH_SCHOOL]: i18n('High School Diploma Required'),
    [EducationLevel.TWO_YEAR_DEGREE]: i18n('2-Year Degree Required'),
    [EducationLevel.FOUR_YEAR_DEGREE]: i18n('4-Year Degree Required'),
    [EducationLevel.MASTERS_DEGREE]: i18n("Master's Degree Required"),
    [EducationLevel.JD]: i18n('J.D. Required'),
    [EducationLevel.PHD]: i18n('Doctorate Required'),
    [EducationLevel.MD]: i18n('M.D. Required'),
    [EducationLevel.OTHER]: i18n('Other Education Requirement'),
  };
}

export const EDUCATION_LEVEL_CHECKBOX_OPTIONS = (i18n: I18nFn) =>
  Object.entries(EDUCATION_LEVELS(i18n)).map(([key, value]) => ({
    name: key,
    label: value,
  }));

export const EDUCATION_RADIO_OR_SELECT_OPTIONS = (i18n: I18nFn) =>
  Object.entries(EDUCATION_LEVELS(i18n)).map(([key, value]) => ({
    value: key,
    label: value,
  }));
